// 테이블 Action 컬럼 아이콘이 같은 기준선과 클릭 영역을 갖도록 공통 슬롯을 맞춘다.
const LIST_ACTION_ICON_BASE_SX = {
    width: 22,
    height: 22,
    p: 0,
    m: 0,
    border: 0,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    lineHeight: 0,
    verticalAlign: 'middle',
    textDecoration: 'none',
    backgroundColor: 'transparent',
    '& .MuiSvgIcon-root': {
        fontSize: 22,
        display: 'block',
    },
}

export const LIST_ACTION_EDIT_BUTTON_SX = {
    ...LIST_ACTION_ICON_BASE_SX,
    color: 'primary.main',
}

export const LIST_ACTION_DELETE_BUTTON_SX = {
    ...LIST_ACTION_ICON_BASE_SX,
    color: 'error.main',
}
